import React from 'react'
import { Grid, Link } from '@mui/material'

const BottomLinks = () => {
  return (
    <>
      <Grid item xs={12} md={12} lg={12}>
        <Link
          id="button-notice-privacy"
          href="https://www.infosel.com/aviso-de-privacidad"
          target="_blank"
          rel="noopener noreferrer"
          color="text.secondary"
          variant="value"
        >
          Aviso de privacidad
        </Link>
      </Grid>
      <Grid item xs={12} md={12} lg={12}>
        <Link
          id="button-email-support"
          href="mailto:soporte@infosel.com"
          rel="noopener noreferrer"
          color="text.secondary"
          variant="value"
        >
          soporte@infosel.com
        </Link>
      </Grid>
    </>
  )
}

export default BottomLinks
